(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9620],{

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PlayButtonWithRipple; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30890);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["colorOrange", "medium", "ripple", "small"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PlayButtonWithRipple = function PlayButtonWithRipple(_ref) {
  var colorOrange = _ref.colorOrange,
      medium = _ref.medium,
      _ref$ripple = _ref.ripple,
      ripple = _ref$ripple === void 0 ? true : _ref$ripple,
      small = _ref.small,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", _objectSpread(_objectSpread({
    className: "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play_btn), " ").concat(colorOrange ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().orange)) : "", " ").concat(medium ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().medium)) : "", " ").concat(small ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small)) : "")
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow_right)
    }), ripple && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ripple_effect)
    })]
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButtonWithRipple);

/***/ }),

/***/ 32182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90705);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89583);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var _uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47384);
/* harmony import */ var _uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var UniThumbGridBox = function UniThumbGridBox(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().box),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      legacyBehavior: true,
      href: props.universityLink,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: props.featuredImage || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/uni-profile/harvard-university.jpg"),
            alt: props.featuredImageAlt || "University banner",
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner)
          }), props.logo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().logo_wrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: props.logo,
              alt: props.logoAlt || "University logo",
              className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().logo)
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().profile_box_content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().infos),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          legacyBehavior: true,
          href: props.universityLink,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().name),
              children: props.name || "University Name"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdLocationOn */ .$0r, {})
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
            children: [props.address && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.address, ", "]
            }), props.city && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.city, ", "]
            }), props.state && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.state, ", "]
            }), props.country && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              children: props.country
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_6__/* .FaUniversity */ .Q7H, {
              style: {
                marginTop: "-4px"
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
            children: [props.universityType && (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .upperFirstLetter */ .cK)(props.universityType), " ", "University, ", props.estd && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: ["Estd ", props.estd]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().follow),
          children: "+ Follow"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().links),
        children: props.courseNumber !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          legacyBehavior: true,
          href: props.courseLink,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().all_courses),
            children: ["View all ", props.courseNumber, " Courses \u203A"]
          })
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (UniThumbGridBox);

/***/ }),

/***/ 97623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yQ": function() { return /* reexport */ UniBrief; },
  "gK": function() { return /* reexport */ UniHeroWithVideo; },
  "pA": function() { return /* reexport */ UniLinks; },
  "q6": function() { return /* reexport */ uni_profile_banner/* UniProfileBanner */.q; },
  "au": function() { return /* reexport */ UniProfileWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./_modules/study/common/play_btn_with_ripple/index.jsx
var play_btn_with_ripple = __webpack_require__(42422);
// EXTERNAL MODULE: ./_modules/study/university/uni_hero_with_video.module.scss
var uni_hero_with_video_module = __webpack_require__(47656);
var uni_hero_with_video_module_default = /*#__PURE__*/__webpack_require__.n(uni_hero_with_video_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/university/uni_hero_with_video.jsx



var ModalVideo = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6635).then(__webpack_require__.bind(__webpack_require__, 61239));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61239)];
    }
  }
});





var UniHeroWithVideo = function UniHeroWithVideo(_ref) {
  var uniProfileData = _ref.uniProfileData;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (uni_hero_with_video_module_default()).uni_hero,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (uni_hero_with_video_module_default()).video_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (uni_hero_with_video_module_default()).overlay
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          layout: "responsive",
          width: 840,
          height: 450,
          blurDataURL: (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
          placeholder: "blur",
          className: (uni_hero_with_video_module_default()).featured_image,
          src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.coverphotoLogoSrc) || (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
          alt: "Video Background"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(play_btn_with_ripple/* default */.Z, {
          onClick: function onClick() {
            return setOpen(true);
          }
        })]
      })
    }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.videoType) === "upload" && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo, {
      channel: "custom",
      autoplay: true,
      isOpen: isOpen,
      url: uniProfileData ? uniProfileData.videoSrc : "",
      onClose: function onClose() {
        return setOpen(false);
      }
    }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.videoType) === "embeded" && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo, {
      channel: "youtube",
      autoplay: true,
      isOpen: isOpen,
      videoId: uniProfileData ? uniProfileData.embedCode : "",
      onClose: function onClose() {
        return setOpen(false);
      }
    })]
  });
};
/* harmony default export */ var uni_hero_with_video = ((/* unused pure expression or super */ null && (UniHeroWithVideo)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Rating/Rating.js + 3 modules
var Rating = __webpack_require__(90926);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(15825);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(58735);
// EXTERNAL MODULE: ./_unisearch/common/index.js + 9 modules
var common = __webpack_require__(74155);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./_modules/study/university/uni_brief.module.scss
var uni_brief_module = __webpack_require__(47022);
var uni_brief_module_default = /*#__PURE__*/__webpack_require__.n(uni_brief_module);
// EXTERNAL MODULE: ./_modules/study/university/uni_reviews/components/guest_form_review.jsx
var guest_form_review = __webpack_require__(17171);
// EXTERNAL MODULE: ./_modules/study/university/uni_reviews/components/register_form_review.jsx
var register_form_review = __webpack_require__(25702);
;// CONCATENATED MODULE: ./_modules/study/university/uni_brief.jsx





















var FavoriteAction = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(726)]).then(__webpack_require__.bind(__webpack_require__, 25494));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(25494)];
    }
  }
});
var CompareAction = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(180)]).then(__webpack_require__.bind(__webpack_require__, 76723));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76723)];
    }
  }
});

var ReviewOption = function ReviewOption(_ref) {
  var value = _ref.value,
      uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData,
      existingComment = _ref.existingComment,
      onEdit = _ref.onEdit,
      getComment = _ref.getComment;

  switch (value) {
    case 0:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(guest_form_review/* default */.Z, {
        getData: getData,
        setModal: setModal,
        uniProfileData: uniProfileData
      });

    case 1:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(register_form_review/* default */.Z, {
        setModal: setModal,
        uniProfileData: uniProfileData,
        getData: getData,
        onEdit: onEdit,
        existingComment: existingComment,
        getComment: getComment
      });
  }
};

var UniBrief = function UniBrief(_ref2) {
  var _uniProfileData$docum, _uniProfileData$docum2;

  var uniProfileData = _ref2.uniProfileData,
      customClasses = _ref2.customClasses;
  var profileInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      modal = _useState[0],
      setModal = _useState[1];

  var _useState2 = (0,react.useState)(0),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      existingComment = _useState3[0],
      setExistingComment = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      onEdit = _useState4[0],
      setOnEdit = _useState4[1];

  var systemActions = (0,_actions/* useSystemActions */.x3)(); // get existing comment

  var getComment = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api/* default.get */.Z.get("/public/university-review/check/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug)).then(function (res) {
                if (!res.error && res.data) {
                  var data = res.data;
                  setExistingComment(data);
                  setOnEdit(true);
                } else {
                  setExistingComment({});
                  setOnEdit(false);
                }
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getComment() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.universitySlug && profileInfo && modal) {
      getComment();
    }
  }, [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug, profileInfo, modal]);
  (0,react.useEffect)(function () {
    if (profileInfo) {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [profileInfo]);

  var getData = function getData() {};

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "".concat((uni_brief_module_default()).section_uni_brief, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (uni_brief_module_default()).brief_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_brief_module_default()).brief_left_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (uni_brief_module_default()).uni_logo_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.logosrc) || (0,helpers/* getAssets */.Vh)("assets/images/uni-profile/logo-placeholder.png"),
              alt: "University Logo"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).uni_brief_info,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              children: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityName
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaUniversity */.Q7H, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.universityType ? (0,helpers/* upperFirstLetter */.cK)(uniProfileData.universityType) : "", " ", "University, Estd ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.estd]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaMapMarkerAlt */.Nh4, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.cityName, ", ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.stateName]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiBook2Fill */.XbY, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalCourse, " ", (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalCourse) > 1 ? "Courses" : "Course"]
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_brief_module_default()).brief_right_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).rating_wrapper,
            children: [(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalRating) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (uni_brief_module_default()).info_rating_number,
              children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating, " (", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalRating, ")"]
            }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (uni_brief_module_default()).info_rating_stars,
              onClick: function onClick() {
                setModal(true);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Rating/* default */.Z, {
                name: "rating-read",
                value: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating) && parseInt(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating),
                readOnly: true
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            rel: "nofollow",
            className: (uni_brief_module_default()).uni_web_link,
            href: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.website,
            target: "_blank",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "International student website"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BiLinkExternal */.rpH, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).compare_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavoriteAction, {
              referance: "university",
              referanceId: parseInt(uniProfileData.universityId),
              is_favorite: (0,helpers/* isUniFavorite */.bt)(profileInfo, uniProfileData.universityId)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompareAction, {
              referance: "university",
              referanceId: parseInt(uniProfileData.universityId),
              is_compared: (0,helpers/* isUniCompare */.j1)(profileInfo, uniProfileData.universityId)
            }), uniProfileData && (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.documentInfo) && /*#__PURE__*/(0,jsx_runtime.jsx)(common/* DownloadGuide */.E6, {
              customClasses: {
                root: "btn-bg"
              },
              fileSrc: uniProfileData === null || uniProfileData === void 0 ? void 0 : (_uniProfileData$docum = uniProfileData.documentInfo) === null || _uniProfileData$docum === void 0 ? void 0 : _uniProfileData$docum.documentSrc,
              documentId: uniProfileData === null || uniProfileData === void 0 ? void 0 : (_uniProfileData$docum2 = uniProfileData.documentInfo) === null || _uniProfileData$docum2 === void 0 ? void 0 : _uniProfileData$docum2.documentId,
              documentType: "prospectus",
              universityId: parseInt(uniProfileData.universityId)
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      open: modal,
      onClose: function onClose() {
        setModal(false);
      },
      closeAfterTransition: true,
      BackdropComponent: Backdrop/* default */.Z,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "modal md",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "modal_head ".concat((uni_brief_module_default()).modal_header),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: "".concat((uni_brief_module_default()).title, " modal_title")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "cross_icon ".concat((uni_brief_module_default()).cross_action),
            onClick: function onClick() {
              setModal(false);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiX */.q5L, {})
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((uni_brief_module_default()).modal_body, " modal_body"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: (uni_brief_module_default()).modal_title,
            children: "Write a Review"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (uni_brief_module_default()).modal_description,
            children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim odio dui, felis ultricies. Scelerisque quam tristique faucibus cras. Malesuada lobortis habitasse et enim vitae lectus tellus. Et volutpat hendrerit iaculis non in adipiscing tincidunt ut."
          }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).action_btn,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              onClick: function onClick() {
                setValue(0);
              },
              className: value === 0 && (uni_brief_module_default()).active_btn,
              children: "Guest User"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              onClick: function onClick() {
                setValue(1);
              },
              className: value === 1 && (uni_brief_module_default()).active_btn,
              children: "Register User"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewOption, {
            setModal: setModal,
            uniProfileData: uniProfileData,
            value: value,
            getData: getData,
            existingComment: existingComment,
            onEdit: onEdit,
            getComment: getComment
          })]
        })]
      })
    })]
  });
};
/* harmony default export */ var uni_brief = ((/* unused pure expression or super */ null && (UniBrief)));
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./_modules/study/university/uni_links.module.scss
var uni_links_module = __webpack_require__(13777);
var uni_links_module_default = /*#__PURE__*/__webpack_require__.n(uni_links_module);
// EXTERNAL MODULE: ./node_modules/country-data/index.js
var country_data = __webpack_require__(3023);
;// CONCATENATED MODULE: ./_modules/study/university/uni_links.jsx













var UniLinks = function UniLinks(props) {
  var _props$uniProfileData, _systemInfo$visitor_c, _systemInfo$visitor_c2, _props$uniProfileData2, _systemInfo$visitor_c3, _systemInfo$visitor_c4, _systemInfo$visitor_c5, _props$uniProfileData3, _props$uniProfileData4, _props$uniProfileData5, _props$uniProfileData6;

  var router = (0,next_router.useRouter)();
  var asPath = router.asPath,
      query = router.query;
  var systemActions = (0,_actions/* useSystemActions */.x3)();
  var systemInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* systemAtom */.K2);

  var _useState = (0,react.useState)({}),
      menuStatus = _useState[0],
      setMenuStatus = _useState[1];

  var coursesLevelPageLink;
  var overviewPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name);
  var admissionFaqPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/admission-faq");
  var rankingPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/ranking");
  var coursesPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/courses");
  query.course_level ? coursesLevelPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/courses/").concat(query.course_level) : "";
  var searchCoursePageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/search-courses");
  var scholarshipsPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/scholarships");
  var scholarshipDetailsPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/scholarships/").concat(query.scholarship_slug);
  var blogPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/blog");
  var staffPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/staff");
  var eventFairPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/event-fair");
  var galleryPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/gallery");
  var reviewPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/reviews");
  var contactPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/contact");

  var getIpInof = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var default_country, _countries$default_co, _countries$default_co2, _countries$default_co4, _countries$default_co5, _countries$default_co3;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              default_country = localStorage.getItem("default_country");

              if (default_country && default_country != "") {
                //set visitor default courrencies
                if ((!(systemInfo !== null && systemInfo !== void 0 && systemInfo.currency) || (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency) == "") && (_countries$default_co = country_data/* countries */.hW[default_country.toUpperCase()]) !== null && _countries$default_co !== void 0 && _countries$default_co.currencies[0] && ((_countries$default_co2 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co2 === void 0 ? void 0 : _countries$default_co2.currencies[0]) != "") {
                  systemActions.setSystemCurrency((_countries$default_co3 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co3 === void 0 ? void 0 : _countries$default_co3.currencies[0]);
                } //set visitor countries


                if ((!(systemInfo !== null && systemInfo !== void 0 && systemInfo.visitor_country) || Object.keys(systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.visitor_country).length === 0) && (_countries$default_co4 = country_data/* countries */.hW[default_country.toUpperCase()]) !== null && _countries$default_co4 !== void 0 && _countries$default_co4.name && ((_countries$default_co5 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co5 === void 0 ? void 0 : _countries$default_co5.name) != "") {
                  systemActions.setVisitorCountry(country_data/* countries */.hW[default_country.toUpperCase()]);
                }
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getIpInof() {
      return _ref.apply(this, arguments);
    };
  }(); //get IP Info


  (0,react.useEffect)(function () {
    getIpInof();
  }, []);
  (0,react.useEffect)(function () {
    function getMenuStatius() {
      return _getMenuStatius.apply(this, arguments);
    }

    function _getMenuStatius() {
      _getMenuStatius = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return api/* default.get */.Z.get("/public/university/menu-status/".concat(query.university_name)).then(function (resp) {
                  if (!resp.error && resp.data) {
                    setMenuStatus(resp.data);
                  } else {
                    setMenuStatus({});
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getMenuStatius.apply(this, arguments);
    }

    getMenuStatius();
  }, [query.university_name]); // set system currency

  var setSystemCurrency = function setSystemCurrency(e) {
    systemActions.setSystemCurrency(e.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (uni_links_module_default()).section_links,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (uni_links_module_default()).links_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (uni_links_module_default()).links_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: (uni_links_module_default()).link_lists,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: overviewPageLink,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === overviewPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Overview"
                })
              })
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.faq && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.faq) === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(admissionFaqPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === admissionFaqPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Admission FAQ"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.ranking && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.ranking) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(rankingPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === rankingPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Rankings"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.course && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.course) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(coursesPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath.split("?")[0] == coursesPageLink || coursesLevelPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Courses"
                })
              })
            }) : "", query.course_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(coursesPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(query.course_slug ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Course Details"
                })
              })
            }), asPath.includes("search-courses") && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Search Courses"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.sholarship && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.sholarship) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(scholarshipsPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === scholarshipsPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Scholarships"
                })
              })
            }) : "", query.scholarship_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Scholarship Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.blog && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.blog) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(blogPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === blogPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Blog"
                })
              })
            }) : "", query.uni_blog_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Blog Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.staff && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.staff) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(staffPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === staffPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Staff"
                })
              })
            }) : "", query.staff_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Staff Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.eventFair && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.eventFair) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(eventFairPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === eventFairPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Event/Fair"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.gallery && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.gallery) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(galleryPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === galleryPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Gallery"
                })
              })
            }) : "", query.slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Gallery Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.review && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.review) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(reviewPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === reviewPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Reviews"
                })
              })
            }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(contactPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === contactPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Contact"
                })
              })
            }), query.course_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("select", {
                name: "currencyCode",
                id: "currencyCode",
                className: (uni_links_module_default()).currencyChanger,
                onChange: setSystemCurrency,
                disabled: systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.loading,
                value: systemInfo !== null && systemInfo !== void 0 && systemInfo.currency && (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency) != "" ? systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency : props === null || props === void 0 ? void 0 : (_props$uniProfileData = props.uniProfileData) === null || _props$uniProfileData === void 0 ? void 0 : _props$uniProfileData.countryCurrency,
                children: systemInfo !== null && systemInfo !== void 0 && systemInfo.loading ? /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                  value: "",
                  children: " Loading "
                }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                  children: [(systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c = systemInfo.visitor_country) === null || _systemInfo$visitor_c === void 0 ? void 0 : _systemInfo$visitor_c.currencies) && (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c2 = systemInfo.visitor_country) === null || _systemInfo$visitor_c2 === void 0 ? void 0 : _systemInfo$visitor_c2.currencies[0].toUpperCase()) != (props === null || props === void 0 ? void 0 : (_props$uniProfileData2 = props.uniProfileData) === null || _props$uniProfileData2 === void 0 ? void 0 : _props$uniProfileData2.countryCurrency.toUpperCase()) && (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c3 = systemInfo.visitor_country) === null || _systemInfo$visitor_c3 === void 0 ? void 0 : _systemInfo$visitor_c3.currencies[0].toUpperCase()) != "USD" && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c4 = systemInfo.visitor_country) === null || _systemInfo$visitor_c4 === void 0 ? void 0 : _systemInfo$visitor_c4.currencies[0].toUpperCase(),
                    children: systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c5 = systemInfo.visitor_country) === null || _systemInfo$visitor_c5 === void 0 ? void 0 : _systemInfo$visitor_c5.currencies[0].toUpperCase()
                  }), (props === null || props === void 0 ? void 0 : (_props$uniProfileData3 = props.uniProfileData) === null || _props$uniProfileData3 === void 0 ? void 0 : _props$uniProfileData3.countryCurrency) && (props === null || props === void 0 ? void 0 : (_props$uniProfileData4 = props.uniProfileData) === null || _props$uniProfileData4 === void 0 ? void 0 : _props$uniProfileData4.countryCurrency) != "USD" && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: props === null || props === void 0 ? void 0 : (_props$uniProfileData5 = props.uniProfileData) === null || _props$uniProfileData5 === void 0 ? void 0 : _props$uniProfileData5.countryCurrency,
                    children: props === null || props === void 0 ? void 0 : (_props$uniProfileData6 = props.uniProfileData) === null || _props$uniProfileData6 === void 0 ? void 0 : _props$uniProfileData6.countryCurrency
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: "USD",
                    children: "USD"
                  })]
                })
              })
            })]
          })
        })
      })
    })
  });
};
/* harmony default export */ var uni_links = ((/* unused pure expression or super */ null && (UniLinks)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_wrapper.module.scss
var uni_profile_wrapper_module = __webpack_require__(98281);
var uni_profile_wrapper_module_default = /*#__PURE__*/__webpack_require__.n(uni_profile_wrapper_module);
// EXTERNAL MODULE: ./_hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(14418);
;// CONCATENATED MODULE: ./_modules/study/university/uni_profile_wrapper.jsx

var _excluded = ["isVideoBanner", "isBanner", "isBreadcrumb", "breadcrumbTitle", "children"];










var UniProfileWrapper = function UniProfileWrapper(_ref) {
  var _ref$isVideoBanner = _ref.isVideoBanner,
      isVideoBanner = _ref$isVideoBanner === void 0 ? true : _ref$isVideoBanner,
      _ref$isBanner = _ref.isBanner,
      isBanner = _ref$isBanner === void 0 ? true : _ref$isBanner,
      _ref$isBreadcrumb = _ref.isBreadcrumb,
      isBreadcrumb = _ref$isBreadcrumb === void 0 ? true : _ref$isBreadcrumb,
      breadcrumbTitle = _ref.breadcrumbTitle,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var uniProfileData = props.uniProfileData;

  var _useWindowDimensions = (0,useWindowDimensions/* default */.Z)(),
      width = _useWindowDimensions.width;

  var router = (0,next_router.useRouter)();
  var query = router.query,
      pathname = router.pathname;
  var targetPathSlug = pathname.split("/")[5];
  var course_slug = query.course_slug;

  var breadCrumbActiveLink = function breadCrumbActiveLink() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "color-orange",
      children: breadcrumbTitle ? breadcrumbTitle : (0,helpers/* generateNavTitle */.He)(targetPathSlug)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [isBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.videoType && isVideoBanner ? /*#__PURE__*/(0,jsx_runtime.jsx)(UniHeroWithVideo, {
        uniProfileData: uniProfileData
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(uni_profile_banner/* UniProfileBanner */.q, {
        uniProfileData: uniProfileData
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UniBrief, {
      uniProfileData: uniProfileData,
      customClasses: {
        root: !isBanner ? (uni_profile_wrapper_module_default()).root : ""
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UniLinks, {
      uniProfileData: uniProfileData
    }), (isBanner || width < 992) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (uni_profile_wrapper_module_default()).uni_breacrumbs,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: "Home"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
        href: "/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.countrySlug, "/university"),
        children: ["Universities in ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.CountryName]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/study/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.countrySlug, "/university/").concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug),
        children: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityName
      }), targetPathSlug && breadCrumbActiveLink()]
    }), children]
  });
};
/* harmony default export */ var uni_profile_wrapper = ((/* unused pure expression or super */ null && (UniProfileWrapper)));
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_banner.jsx
var uni_profile_banner = __webpack_require__(69805);
;// CONCATENATED MODULE: ./_modules/study/university/index.js






/***/ }),

/***/ 69805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ UniProfileBanner; }
/* harmony export */ });
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98576);
/* harmony import */ var _uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var UniProfileBanner = function UniProfileBanner(_ref) {
  var uniProfileData = _ref.uniProfileData;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("section", {
    className: (_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section_banner),
    children: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.featureSrc) &&
    /*#__PURE__*/
    // <div className={styles.banner_wrapper}>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        layout: "responsive",
        width: 1905,
        height: 450,
        blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
        placeholder: "blur",
        className: (_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner_image),
        src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.featureSrc) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
        alt: "Video Background"
      })
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UniProfileBanner)));

/***/ }),

/***/ 55912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UniProfileLinks */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var UniProfileLinks = function UniProfileLinks(props) {
  var pageData = props.pageData;
  var link = useRouter();
  var asPath = link.asPath,
      query = link.query;
  var universityName = query.university_name;
  var countryName = query.country_name;
  var courseName = query.course_slug;
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_links,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.links_wrapper,
      children: /*#__PURE__*/_jsx("div", {
        className: "container",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.links_container,
          children: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName) ? "".concat(styles.active) : ""),
                  children: "Overview"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/admission-faq"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/admission-faq") ? "".concat(styles.active) : ""),
                  children: "Admission FAQs"
                })
              })
            }), (props === null || props === void 0 ? void 0 : props.showRankingTab) && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/ranking"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/ranking") ? "".concat(styles.active) : ""),
                  children: "Ranking"
                })
              })
            }), (props === null || props === void 0 ? void 0 : props.showScholarshipTab) && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/scholarships"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/scholarships") ? "".concat(styles.active) : ""),
                  children: "Scholarships"
                })
              })
            }), (props === null || props === void 0 ? void 0 : props.showCourseTab) && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/courses"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/courses") ? "".concat(styles.active) : ""),
                  children: "Courses"
                })
              })
            }), asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/").concat(courseName) && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/").concat(countryName),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/").concat(courseName) ? "".concat(styles.active) : ""),
                  children: "Course Details"
                })
              })
            }), (pageData === null || pageData === void 0 ? void 0 : pageData.length) > 0 && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/blog"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/blog") ? "".concat(styles.active) : ""),
                  children: "Blog"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/staff"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/staff") ? "".concat(styles.active) : ""),
                  children: "Staff"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/event-fair"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/event-fair") ? "".concat(styles.active) : ""),
                  children: "Event/Fair"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/gallery"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/gallery") ? "".concat(styles.active) : ""),
                  children: "Gallery"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/contact"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/contact") ? "".concat(styles.active) : ""),
                  children: "Contact"
                })
              })
            })]
          })
        })
      })
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UniProfileLinks)));

/***/ }),

/***/ 65111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UniProfileUniBox */
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73873);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41548);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_uni_thumb_grid_box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32182);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var UniProfileUniBox = function UniProfileUniBox(_ref) {
  var universities = _ref.universities;
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1400,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 4
      }
    }, {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 1
      }
    }]
  };
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_uni_profile_box,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.uni_profile_box,
      children: /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, settings), {}, {
        children: universities === null || universities === void 0 ? void 0 : universities.slice(0, 10).map(function (university, i) {
          var _university$country, _university$featuredI, _university$featuredI2, _university$logo, _university$logo2, _university$city, _university$state, _university$country2, _university$country3;

          return /*#__PURE__*/_jsx(UniThumbGridBox, {
            universityLink: "/study/".concat(university === null || university === void 0 ? void 0 : (_university$country = university.country) === null || _university$country === void 0 ? void 0 : _university$country.slug, "/university/").concat(university === null || university === void 0 ? void 0 : university.slug),
            name: university === null || university === void 0 ? void 0 : university.name,
            featuredImage: university === null || university === void 0 ? void 0 : (_university$featuredI = university.featuredImage) === null || _university$featuredI === void 0 ? void 0 : _university$featuredI.src,
            featuredImageAlt: university === null || university === void 0 ? void 0 : (_university$featuredI2 = university.featuredImage) === null || _university$featuredI2 === void 0 ? void 0 : _university$featuredI2.alt,
            logo: university === null || university === void 0 ? void 0 : (_university$logo = university.logo) === null || _university$logo === void 0 ? void 0 : _university$logo.src,
            logoAlt: university === null || university === void 0 ? void 0 : (_university$logo2 = university.logo) === null || _university$logo2 === void 0 ? void 0 : _university$logo2.alt,
            address: university === null || university === void 0 ? void 0 : university.address,
            city: (university === null || university === void 0 ? void 0 : (_university$city = university.city) === null || _university$city === void 0 ? void 0 : _university$city.name) || "City",
            state: (university === null || university === void 0 ? void 0 : (_university$state = university.state) === null || _university$state === void 0 ? void 0 : _university$state.name) || "State",
            country: (university === null || university === void 0 ? void 0 : (_university$country2 = university.country) === null || _university$country2 === void 0 ? void 0 : _university$country2.name) || "Country",
            universityType: university.universityType,
            estd: university === null || university === void 0 ? void 0 : university.estd,
            courseLink: "/study/".concat(university === null || university === void 0 ? void 0 : (_university$country3 = university.country) === null || _university$country3 === void 0 ? void 0 : _university$country3.slug, "/university/").concat(university === null || university === void 0 ? void 0 : university.slug, "/courses"),
            courseNumber: university.course.length
          }, university.id);
        })
      }))
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UniProfileUniBox)));

/***/ }),

/***/ 4013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k_": function() { return /* reexport */ UniRanking; }
});

// UNUSED EXPORTS: UniProfileBanner, UniProfileLinks, UniProfileUniBox

// EXTERNAL MODULE: ./_modules/study/university/uni_profile_banner.jsx
var uni_profile_banner = __webpack_require__(69805);
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_links.jsx
var uni_profile_links = __webpack_require__(55912);
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_uni_box.jsx
var uni_profile_uni_box = __webpack_require__(65111);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./_unisearch/helpers/utils.js
var utils = __webpack_require__(90705);
// EXTERNAL MODULE: ./_modules/study/university/uni_ranking/uni_ranking.module.scss
var uni_ranking_module = __webpack_require__(38927);
var uni_ranking_module_default = /*#__PURE__*/__webpack_require__.n(uni_ranking_module);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./_modules/study/common/course_ranking_card/course_ranking_card.module.scss
var course_ranking_card_module = __webpack_require__(97331);
var course_ranking_card_module_default = /*#__PURE__*/__webpack_require__.n(course_ranking_card_module);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/common/course_ranking_card/index.jsx

var _excluded = ["rank"];










var CourseRankingCard = function CourseRankingCard(_ref) {
  var _rank$ranking$, _rank$ranking$2, _rank$ranking$3, _rank$ranking$4, _rank$ranking$5, _rank$ranking$6, _rank$ranking$7;

  var rank = _ref.rank,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (course_ranking_card_module_default()).course_ranking_card,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (course_ranking_card_module_default()).ranking_heading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
        className: (course_ranking_card_module_default()).trophy_icon,
        src: (0,helpers/* getAssets */.Vh)("assets/images/uni-profile/trophy-icon.svg")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (course_ranking_card_module_default()).rank_num,
        children: [rank === null || rank === void 0 ? void 0 : (_rank$ranking$ = rank.ranking[0]) === null || _rank$ranking$ === void 0 ? void 0 : _rank$ranking$.rankingVarying, " ", rank === null || rank === void 0 ? void 0 : (_rank$ranking$2 = rank.ranking[0]) === null || _rank$ranking$2 === void 0 ? void 0 : _rank$ranking$2.rankFrom, " ", rank !== null && rank !== void 0 && (_rank$ranking$3 = rank.ranking[0]) !== null && _rank$ranking$3 !== void 0 && _rank$ranking$3.rankTo && parseInt(rank === null || rank === void 0 ? void 0 : (_rank$ranking$4 = rank.ranking[0]) === null || _rank$ranking$4 === void 0 ? void 0 : _rank$ranking$4.rankTo) > 0 ? "- ".concat(rank === null || rank === void 0 ? void 0 : (_rank$ranking$5 = rank.ranking[0]) === null || _rank$ranking$5 === void 0 ? void 0 : _rank$ranking$5.rankTo) : ""]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (course_ranking_card_module_default()).rank_year,
        children: ["in ", rank === null || rank === void 0 ? void 0 : (_rank$ranking$6 = rank.ranking[0]) === null || _rank$ranking$6 === void 0 ? void 0 : _rank$ranking$6.rankingYear]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (course_ranking_card_module_default()).ranking_title,
      children: [rank.rankingCompanyName, " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: ["( ", rank === null || rank === void 0 ? void 0 : (_rank$ranking$7 = rank.ranking[0]) === null || _rank$ranking$7 === void 0 ? void 0 : _rank$ranking$7.type.rankingTypeName, " )"]
      })]
    }), rank.ranking && rank.ranking.length > 0 && rank.ranking.map(function (item, i) {
      if (i > 0) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((course_ranking_card_module_default()).rank_list),
            onClick: function onClick() {
              return handleCollapse(item.id);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (course_ranking_card_module_default()).num,
              children: [item === null || item === void 0 ? void 0 : item.rankingVarying, item === null || item === void 0 ? void 0 : item.rankFrom, " ", item !== null && item !== void 0 && item.rankTo && parseInt(item === null || item === void 0 ? void 0 : item.rankTo) > 0 ? " - ".concat(item === null || item === void 0 ? void 0 : item.rankTo) : "", ","]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (course_ranking_card_module_default()).text,
              children: [item === null || item === void 0 ? void 0 : item.type.rankingTypeName, ", ", item === null || item === void 0 ? void 0 : item.rankingYear]
            })]
          })
        }, i);
      }
    })]
  });
};

/* harmony default export */ var course_ranking_card = (CourseRankingCard);
;// CONCATENATED MODULE: ./_modules/study/university/uni_ranking/uni_ranking.jsx

var uni_ranking_excluded = ["rankingInfo", "rankingOverviewText"];

/* eslint-disable @next/next/no-img-element */









var UniRanking = function UniRanking(_ref) {
  var rankingInfo = _ref.rankingInfo,
      rankingOverviewText = _ref.rankingOverviewText,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, uni_ranking_excluded);

  var rankingCompany = rankingInfo.rankingCompany,
      universityRanking = rankingInfo.universityRanking;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (uni_ranking_module_default()).wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((uni_ranking_module_default()).title_wrapper, " ").concat((uni_ranking_module_default()).heading),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "Understanding University Rankings"
          }), rankingOverviewText ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: rankingOverviewText && (0,utils/* htmlParse */.QA)(rankingOverviewText)
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "In the process of researching universities you want to apply to, you\u2019ve likely run into university rankings. But what do these numbers mean? A lot goes into informing the position a university or college holds in some of the most popular ranking lists. QS Top Universities, Times Higher Education, US News, Shanghai Rankings, etc. all collect and analyse a lot of data to determine what makes a university a great destination for students. Understanding this data also helps you figure out how to choose the right university for yourself!"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "While each of the major world university rankings has its own methodologies, using a set of indicators with different weightages to calculate that #4 or =99 or #201-250, there are a few consistent areas of overlap. Metrics typically look at the quality of education, teaching quality, employability of graduates, research outlook and reputation, research impact, international outlook, and more, to determine a university\u2019s standing among thousands of other institutions. Because different rankings prioritise different metrics and measure and weigh them differently, you\u2019ll also find that sometimes the university ranking impressively high in one ranking holds a more modest position elsewhere."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "So, what does it all mean? Rankings are definitely a good way to shortlist universities you\u2019re considering, especially when broken down into subject rankings to see how a university performs within a specific field. You can filter down your university search based on your preferences, focusing more on universities with a higher employability rate, or better international outlook. Rankings aren\u2019t, however, conclusive information about how good one university is versus another. After all, one can only estimate how great the teaching environment is in a university, how friendly the community is to international students, and how good of a fit it is to your academic pursuits. The right university for you might not be one that appears high up on a ranking list. So, it\u2019s important to use rankings to assist your university search, not limit it!"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_ranking_module_default()).ranking_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            spacing: 4,
            children: universityRanking && universityRanking.length > 0 && universityRanking.map(function (rank, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(course_ranking_card, {
                  rank: rank
                })
              }, "rank".concat(index));
            })
          }), rankingCompany && (rankingCompany === null || rankingCompany === void 0 ? void 0 : rankingCompany.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_ranking_module_default()).title_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: "Top World University Rankings"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (uni_ranking_module_default()).short_description,
              children: "Below, we list out the most comprehensive world university rankings, which derive data from credible sources and use validated methodologies and reliable metrics to see how universities compare on a global scale."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (uni_ranking_module_default()).ranking_company_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                children: rankingCompany && (rankingCompany === null || rankingCompany === void 0 ? void 0 : rankingCompany.map(function (company, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      legacyBehavior: true,
                      href: "/study/raniking-company/".concat(company.slug),
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                        children: [(company === null || company === void 0 ? void 0 : company.logoImageSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: (uni_ranking_module_default()).rank_company_logo_wrapper,
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                            src: company === null || company === void 0 ? void 0 : company.logoImageSrc,
                            alt: company === null || company === void 0 ? void 0 : company.logoImageAlt
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: (uni_ranking_module_default()).rank_company_title,
                          children: company === null || company === void 0 ? void 0 : company.rankingCompanyName
                        }), (company === null || company === void 0 ? void 0 : company.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: (uni_ranking_module_default()).rank_company_desc,
                          children: (0,utils/* htmlParse */.QA)(company.description)
                        })]
                      })
                    })
                  }, i);
                }))
              })
            })]
          })]
        })]
      })
    })
  });
};
/* harmony default export */ var uni_ranking = ((/* unused pure expression or super */ null && (UniRanking)));
;// CONCATENATED MODULE: ./_modules/study/university/uni_ranking/index.js





/***/ }),

/***/ 17171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28719);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88740);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72145);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var customStyles = {
  control: function control(base, state) {
    var _objectSpread2;

    return _objectSpread(_objectSpread({}, base), {}, (_objectSpread2 = {
      height: "60px",
      boxShadow: state.isFocused ? "0px 4px 15px rgba(244, 127, 32, 0.15)" : "none",
      borderColor: "#eeeeee",
      "&:hover": {
        borderColor: "#eeeeee"
      }
    }, (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "borderColor", state.isFocused ? "#F47F20" : "#eeeeee"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "backgroundColor", "#fff"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "fontSize", "13px"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "borderRadius", "8px"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "padding", "0 20px"), _objectSpread2));
  },
  option: function option(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      cursor: "pointer",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      fontSize: "13px",
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  },
  menuPortal: function menuPortal(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      zIndex: 9999
    });
  }
};
var init = {
  universityId: undefined,
  rating: undefined,
  reviewerType: "guest",
  reviewerName: "",
  reviewerEmail: "",
  reviewComment: "",
  reviewerPhone: "",
  reviewerCountryId: undefined
};

var GuestFormReview = function GuestFormReview(_ref) {
  var uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var asPath = router.asPath;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      lastName = _useState[0],
      setLastName = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      countryList = _useState2[0],
      setCountryList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(init),
      formData = _useState3[0],
      setFormData = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("in"),
      defaultCountryCode = _useState4[0],
      setDefaultCountryCode = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setTimeout(function () {
      if (js_cookie__WEBPACK_IMPORTED_MODULE_9__/* ["default"].get */ .Z.get("default_country")) {
        setDefaultCountryCode(js_cookie__WEBPACK_IMPORTED_MODULE_9__/* ["default"].get */ .Z.get("default_country"));
      }
    }, 1500);
  }, [defaultCountryCode]); // all country list

  var getCountryList = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/public/country/dropdown").then(function (res) {
                if (!res.error) {
                  setCountryList(res.data);
                } else {
                  setCountryList([]);
                }
              })["catch"](function (error) {
                setCountryList([]);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getCountryList() {
      return _ref2.apply(this, arguments);
    };
  }(); // fetch only country


  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    getCountryList();
  }, []); // validation schema

  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
    rating: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Please give rating"),
    reviewerName: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewerEmail: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewerCountryId: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewComment: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required")
  });

  var handleSubmitForm = /*#__PURE__*/function () {
    var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                universityId: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityId,
                rating: values.rating,
                reviewerType: "guest",
                reviewerName: "".concat(values.reviewerName, " ").concat(lastName),
                reviewerEmail: values.reviewerEmail,
                reviewComment: values.reviewComment,
                reviewerPhone: values.reviewerPhone,
                reviewerCountryId: values.reviewerCountryId
              };
              _context3.next = 3;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/public/university-review", payload).then( /*#__PURE__*/function () {
                var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (res.error) {
                            _context2.next = 8;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .swalSuccess */ .Xt)("Submitted");
                          setModal(false);
                          _context2.next = 5;
                          return getData();

                        case 5:
                          router.push(asPath);
                          _context2.next = 9;
                          break;

                        case 8:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .swalError */ .Kj)(res === null || res === void 0 ? void 0 : res.message, "Sorry");

                        case 9:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmitForm(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wrapper),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Formik */ .J9, {
      initialValues: formData,
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: function onSubmit(values) {
        handleSubmitForm(values);
      },
      children: function children(_ref5) {
        var handleSubmit = _ref5.handleSubmit,
            setFieldValue = _ref5.setFieldValue,
            values = _ref5.values,
            errors = _ref5.errors,
            touched = _ref5.touched;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
          className: "form",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
            className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().rating_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              sx: {
                fontSize: "50px"
              },
              value: values.rating,
              name: "rating",
              onChange: function onChange(event, newValue) {
                setFieldValue("rating", newValue);
              }
            }), errors.rating && touched.rating && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              className: "invalid-feedback frontend",
              children: errors.rating
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
            container: true,
            spacing: 4,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "First Name"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  type: "text",
                  placeholder: "First Name",
                  onChange: function onChange(e) {
                    setFieldValue("reviewerName", e.target.value);
                  },
                  value: values.reviewerName
                })]
              }), errors.reviewerName && touched.reviewerName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerName
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Last Name"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  onChange: function onChange(e) {
                    setLastName(e.target.value);
                  },
                  type: "text",
                  placeholder: "Last Name"
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Email Address"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  type: "text",
                  placeholder: "Email Address",
                  name: "reviewerEmail",
                  onChange: function onChange(e) {
                    setFieldValue("reviewerEmail", e.target.value);
                  },
                  value: values.reviewerEmail
                })]
              }), errors.reviewerEmail && touched.reviewerEmail && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerEmail
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Phone Number"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_8___default()), {
                  placeholder: "Phone Number",
                  country: defaultCountryCode !== null && defaultCountryCode !== void 0 ? defaultCountryCode : "in",
                  countryCodeEditable: false,
                  value: values.phone,
                  onChange: function onChange(_value, country, _event, formattedValue) {
                    setFieldValue("reviewerPhone", formattedValue);
                  },
                  className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().phoneInput)
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Country"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  id: "reviewerCountryId",
                  name: "reviewerCountryId",
                  placeholder: "Select Your Country",
                  options: countryList !== null && countryList !== void 0 ? countryList : [],
                  multi: false,
                  styles: customStyles,
                  onChange: function onChange(item) {
                    setFieldValue("reviewerCountryId", item.value);
                  },
                  value: countryList ? countryList.filter(function (item) {
                    return item.value == (values === null || values === void 0 ? void 0 : values.reviewerCountryId);
                  }) : {}
                })]
              }), errors.reviewerCountryId && touched.reviewerCountryId && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerCountryId
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 12,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().text_input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Write Your Review"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("textarea", {
                  style: {
                    resize: "vertical"
                  },
                  name: "reviewComment",
                  onChange: function onChange(e) {
                    setFieldValue("reviewComment", e.target.value);
                  },
                  value: values.reviewComment,
                  type: "text",
                  placeholder: "Write Here"
                })]
              }), errors.reviewComment && touched.reviewComment && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewComment
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              sm: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().action_btn),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
                  onClick: function onClick() {
                    return handleSubmit;
                  },
                  type: "submit",
                  className: "btn btn-secondary btn-md",
                  children: "Submit Review"
                })
              })
            })]
          })]
        });
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GuestFormReview);

/***/ }),

/***/ 25702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74231);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88740);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72145);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2804);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89093);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8612);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



/* eslint-disable react-hooks/exhaustive-deps */















var init = {
  universityId: undefined,
  rating: undefined,
  reviewerType: "registered",
  reviewComment: ""
};

var RegisterFormReview = function RegisterFormReview(_ref) {
  var uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData,
      onEdit = _ref.onEdit,
      existingComment = _ref.existingComment,
      getComment = _ref.getComment;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
  var asPath = router.asPath;
  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_7__/* .authAtom */ .L4);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(init),
      formData = _useState[0],
      setFormData = _useState[1];

  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_9__/* .useSystemActions */ .x3)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (onEdit) {
      setFormData({
        universityId: parseInt(existingComment === null || existingComment === void 0 ? void 0 : existingComment.universityId),
        rating: parseInt(existingComment === null || existingComment === void 0 ? void 0 : existingComment.rating),
        reviewerType: "registered",
        reviewComment: existingComment === null || existingComment === void 0 ? void 0 : existingComment.reviewComment
      });
    } else {
      setFormData(init);
    }
  }, [onEdit, existingComment]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    systemActions.removeReturnUrl();
  }, []); // validation schema

  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry().shape({
    rating: yup__WEBPACK_IMPORTED_MODULE_4__/* .number */ .Rx().required("Field is required"),
    reviewComment: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required("Field is required")
  });

  var handleSubmitForm = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                universityId: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityId,
                rating: values.rating,
                reviewerType: "registered",
                reviewerId: profileInfo.id,
                reviewComment: values.reviewComment // reviewerName: `${profileInfo.firstName} ${profileInfo.middleName} ${profileInfo.lastName}`,
                // reviewerEmail: profileInfo.email,
                // reviewerPhone: profileInfo.mobile,
                // reviewerCountryId: profileInfo.countryId,

              };

              if (!onEdit) {
                _context3.next = 6;
                break;
              }

              _context3.next = 4;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].patch */ .Z.patch("/public/university-review/".concat(existingComment === null || existingComment === void 0 ? void 0 : existingComment.universityReviewId), payload).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (res.error) {
                            _context.next = 8;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__/* .swalSuccess */ .Xt)("Updated");
                          setModal(false);
                          _context.next = 5;
                          return getData();

                        case 5:
                          _context.next = 7;
                          return getComment();

                        case 7:
                          router.push(asPath);

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 4:
              _context3.next = 8;
              break;

            case 6:
              _context3.next = 8;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/public/university-review", payload).then( /*#__PURE__*/function () {
                var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (res.error) {
                            _context2.next = 7;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__/* .swalSuccess */ .Xt)("Submitted");
                          setModal(false);
                          _context2.next = 5;
                          return getData();

                        case 5:
                          _context2.next = 7;
                          return getComment();

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmitForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getSign = /*#__PURE__*/function () {
    var _ref5 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              systemActions.setReturnUrl(router.asPath);
              _context4.next = 3;
              return router.push({
                pathname: "/signin"
              });

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getSign() {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
    className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper),
    children: profileInfo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
      initialValues: formData,
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: function onSubmit(values) {
        handleSubmitForm(values);
      },
      children: function children(_ref6) {
        var handleSubmit = _ref6.handleSubmit,
            setFieldValue = _ref6.setFieldValue,
            values = _ref6.values,
            errors = _ref6.errors,
            touched = _ref6.touched;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
          className: "form",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rating_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
              sx: {
                fontSize: "50px",
                mt: 3
              },
              value: parseInt(values.rating),
              name: "rating",
              onChange: function onChange(event, newValue) {
                setFieldValue("rating", newValue);
              }
            }), errors.rating && touched.rating && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "invalid-feedback frontend",
              children: errors.rating
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
            container: true,
            spacing: 4,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
              item: true,
              md: 12,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text_input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("label", {
                  children: "Write your review"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("textarea", {
                  style: {
                    resize: "vertical"
                  },
                  name: "reviewComment",
                  onChange: function onChange(e) {
                    setFieldValue("reviewComment", e.target.value);
                  },
                  value: values.reviewComment,
                  type: "text",
                  placeholder: "Write Here"
                })]
              }), errors.reviewComment && touched.reviewComment && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewComment
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
              item: true,
              sm: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().action_btn),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                  onClick: function onClick() {
                    return handleSubmit;
                  },
                  type: "submit",
                  className: "btn btn-secondary btn-md",
                  children: onEdit ? "Update Review" : "Submit Review"
                })
              })
            })]
          })]
        });
      }
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
      style: {
        width: "100%",
        marginTop: "20px"
      },
      onClick: getSign,
      className: "btn btn-secondary btn-bg",
      children: "Sign in"
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RegisterFormReview);

/***/ }),

/***/ 74155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E6": function() { return /* reexport */ DownloadGuide; },
  "qq": function() { return /* reexport */ MessageComponent; },
  "Dk": function() { return /* reexport */ PersonList; },
  "sk": function() { return /* reexport */ common_form/* UniEditorSmall */.sk; },
  "z9": function() { return /* reexport */ useIsMount; }
});

// UNUSED EXPORTS: DatePickerComponent, DateRangeComponent, Dropdown, Editor, ImageInput, MultipleFileInput, PersonProfile, TimePeriod, Title, UniEditor, UniEditorDefault, UniEditorMedium, UniSugessions

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/title.jsx




var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.heading,
    children: [title && /*#__PURE__*/_jsx("h3", {
      children: title
    }), subtitle && /*#__PURE__*/_jsx("p", {
      children: subtitle
    })]
  });
};
/* harmony default export */ var title = ((/* unused pure expression or super */ null && (Title)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/dropdown.jsx


var _excluded = (/* unused pure expression or super */ null && (["topLabel", "bottomLabel", "options", "placeholder", "className", "selectedValue", "inputId", "onChange", "register"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Dropdown = function Dropdown(_ref) {
  var topLabel = _ref.topLabel,
      bottomLabel = _ref.bottomLabel,
      options = _ref.options,
      placeholder = _ref.placeholder,
      className = _ref.className,
      selectedValue = _ref.selectedValue,
      inputId = _ref.inputId,
      _onChange = _ref.onChange,
      register = _ref.register,
      rest = _objectWithoutProperties(_ref, _excluded);

  // const [value, setValue] = useState("");
  // useEffect(() => {
  //   setValue(selectedValue);
  // }, [selectedValue]);
  // const handleChange = (e) => {
  //   const { label, value } = e;
  //   setValue(value);
  //   if (onChange) {
  //     onChange(e);
  //   }
  // };
  var customStyles = {
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, _defineProperty({
        height: "50px",
        boxShadow: " 0px 2px 5px rgba(38, 51, 77, 0.03)",
        borderColor: "none",
        "&:hover": {
          borderColor: "none"
        }
      }, "borderColor", state.isFocused ? "#e0e0e0" : "#e0e0e0"));
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        cursor: "pointer",
        color: state.isSelected ? "#F47F20" : "#B5B5C3",
        backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
        "&:hover": {
          backgroundColor: "#F5F6FC",
          color: "#F47F20"
        }
      });
    },
    menuPortal: function menuPortal(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      });
    }
  };
  return /*#__PURE__*/_jsxs(FormControl, {
    fullWidth: true,
    children: [topLabel && /*#__PURE__*/_jsx("label", {
      className: topLabel === "transparent" && styles.transparent,
      children: topLabel
    }), /*#__PURE__*/_jsx(Select, _defineProperty({
      className: "".concat(styles.select_input, " ").concat(className),
      options: options,
      onChange: _onChange,
      placeholder: placeholder && placeholder,
      styles: customStyles
    }, "onChange", function onChange(val) {
      return _onChange(val.value);
    })), bottomLabel && /*#__PURE__*/_jsx("label", {
      children: bottomLabel
    })]
  });
};
/* harmony default export */ var dropdown = ((/* unused pure expression or super */ null && (Dropdown)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/useIsMount.jsx

var useIsMount = function useIsMount() {
  var isMountRef = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/index.js



// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(59742);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(80471);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/react-timeago/es6/index.js
var es6 = __webpack_require__(92042);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/person_list/list.module.scss
var list_module = __webpack_require__(6867);
var list_module_default = /*#__PURE__*/__webpack_require__.n(list_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_list/index.jsx



/* eslint-disable @next/next/no-img-element */

















var PersonList = function PersonList(_ref) {
  var _connectedUserList$so;

  var data = _ref.data,
      clickHandler = _ref.clickHandler,
      chatId = _ref.chatId,
      setCurrentChat = _ref.setCurrentChat,
      socket = _ref.socket,
      connectedUserList = _ref.connectedUserList,
      getConnectedUserList = _ref.getConnectedUserList,
      loading = _ref.loading,
      setLoading = _ref.setLoading,
      customClasses = _ref.customClasses,
      closeDrawer = _ref.closeDrawer;

  var _useState = (0,react.useState)(),
      activeProfile = _useState[0],
      setActiveProfile = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      userList = _useState3[0],
      setUserList = _useState3[1];

  var router = (0,next_router.useRouter)(); // open chat box

  var handleClick = function handleClick(person) {
    if (clickHandler) clickHandler(person);
  };

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  }; // get university list to add into friend list


  var getUserList = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(keyword) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (keyword && keyword.length >= 2 && keyword != "") {
                setLoading(true);
                setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return api/* default.get */.Z.get("/chat-service/get-users/".concat(keyword)).then(function (res) {
                            if (!res.error) {
                              setUserList(res.data);
                              setLoading(false);
                            }
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 2000);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getUserList(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // add user into chat list


  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(payload) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return api/* default.post */.Z.post("/chat-service/add-user", {
                recieverId: parseInt((payload === null || payload === void 0 ? void 0 : payload.userTypeSlug) === "mentor" ? payload === null || payload === void 0 ? void 0 : payload.id : payload === null || payload === void 0 ? void 0 : payload.universityId),
                recieverType: payload === null || payload === void 0 ? void 0 : payload.userTypeSlug,
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(res) {
                  var _res$data;

                  return regenerator_default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (res.error) {
                            _context3.next = 7;
                            break;
                          }

                          handleClose();
                          _context3.next = 4;
                          return getConnectedUserList();

                        case 4:
                          setUserList([]);
                          setActiveProfile();
                          router.push("/app/student/messages?chatId=".concat((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.uid));

                        case 7:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((list_module_default()).list_wrapper, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (list_module_default()).header_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: "btn btn-sm btn-outline-grey ".concat((list_module_default()).btn_add_user),
          onClick: handleOpen,
          children: "New User"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {
          className: (list_module_default()).btn_close,
          onClick: closeDrawer
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(IconButton_IconButton/* default */.Z, {
          onClick: handleOpen,
          className: "".concat((list_module_default()).btn_plus, " relative"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "uni-tooltip",
            children: "New User"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (list_module_default()).chatt_box_wrapper,
        children: connectedUserList && (connectedUserList === null || connectedUserList === void 0 ? void 0 : connectedUserList.length) > 0 && (connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$so = connectedUserList.sort(function (a, b) {
          var _b$recentMsg, _b$recentMsg$chat_ser, _a$recentMsg;

          return b === null || b === void 0 ? void 0 : (_b$recentMsg = b.recentMsg) === null || _b$recentMsg === void 0 ? void 0 : (_b$recentMsg$chat_ser = _b$recentMsg.chat_service_message_senderTime) === null || _b$recentMsg$chat_ser === void 0 ? void 0 : _b$recentMsg$chat_ser.localeCompare(a === null || a === void 0 ? void 0 : (_a$recentMsg = a.recentMsg) === null || _a$recentMsg === void 0 ? void 0 : _a$recentMsg.chat_service_message_senderTime);
        })) === null || _connectedUserList$so === void 0 ? void 0 : _connectedUserList$so.map(function (item, index) {
          var _item$receiver, _item$receiver$name, _item$receiver2, _item$receiver3, _item$receiver4, _item$receiver5, _item$receiver6, _item$recentMsg, _item$recentMsg2, _item$recentMsg3;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              handleClick(item);
              setCurrentChat(item === null || item === void 0 ? void 0 : item.receiver);
              setActiveProfile(item);

              if (closeDrawer) {
                closeDrawer();
              }
            },
            className: item && (item === null || item === void 0 ? void 0 : item.uid) == chatId ? (list_module_default()).active_chatt_box : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  style: (item === null || item === void 0 ? void 0 : (_item$receiver = item.receiver) === null || _item$receiver === void 0 ? void 0 : _item$receiver.userTypeSlug) === "university" ? {
                    objectFit: "contain"
                  } : {},
                  alt: (_item$receiver$name = item === null || item === void 0 ? void 0 : (_item$receiver2 = item.receiver) === null || _item$receiver2 === void 0 ? void 0 : _item$receiver2.name) !== null && _item$receiver$name !== void 0 ? _item$receiver$name : "",
                  src: item !== null && item !== void 0 && (_item$receiver3 = item.receiver) !== null && _item$receiver3 !== void 0 && _item$receiver3.media ? (item === null || item === void 0 ? void 0 : (_item$receiver4 = item.receiver) === null || _item$receiver4 === void 0 ? void 0 : _item$receiver4.media) === null ? (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png") : item === null || item === void 0 ? void 0 : (_item$receiver5 = item.receiver) === null || _item$receiver5 === void 0 ? void 0 : _item$receiver5.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (list_module_default()).chatt_msg,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    children: item === null || item === void 0 ? void 0 : (_item$receiver6 = item.receiver) === null || _item$receiver6 === void 0 ? void 0 : _item$receiver6.name
                  }), item !== null && item !== void 0 && item.recentMsg ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: item === null || item === void 0 ? void 0 : (_item$recentMsg = item.recentMsg) === null || _item$recentMsg === void 0 ? void 0 : _item$recentMsg.chat_service_message_messages
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "You Are Connected"
                  })]
                }), (item === null || item === void 0 ? void 0 : (_item$recentMsg2 = item.recentMsg) === null || _item$recentMsg2 === void 0 ? void 0 : _item$recentMsg2.chat_service_message_createdAt) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (list_module_default()).time,
                  children: moment_default()(item === null || item === void 0 ? void 0 : (_item$recentMsg3 = item.recentMsg) === null || _item$recentMsg3 === void 0 ? void 0 : _item$recentMsg3.chat_service_message_senderTime).fromNow()
                })]
              })]
            })
          }, "plist_".concat(index, "_").concat(item.id));
        }))
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
      open: open,
      onClose: handleClose,
      sx: {
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "600px",
            paddingRight: "2px"
          }
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
        children: ["Start a New Chat", /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
          "aria-label": "close",
          onClick: handleClose,
          sx: {
            position: "absolute",
            right: 8,
            top: 12,
            color: function color(theme) {
              return theme.palette.grey[500];
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgClose */.Fk5, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
        dividers: true,
        sx: {
          padding: "0",
          minHeight: "50vh",
          maxHeight: "50vh"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (list_module_default()).search_input_modal,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            autoFocus: true,
            onChange: function onChange(e) {
              getUserList(e.target.value);
            },
            type: "text",
            placeholder: "Search User"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiSearch */.jRj, {
            className: (list_module_default()).search_icon,
            style: {
              fontSize: "20px"
            }
          })]
        }), userList && (userList === null || userList === void 0 ? void 0 : userList.length) > 0 && !loading && (userList === null || userList === void 0 ? void 0 : userList.map(function (item, i) {
          var _item$fullName;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              setActiveProfile(item);
            },
            className: activeProfile && activeProfile.email === item.email ? (list_module_default()).active_chatt_box_modal : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: item.mediaSrc ? item.mediaSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
                  alt: (_item$fullName = item.fullName) !== null && _item$fullName !== void 0 ? _item$fullName : ""
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).chatt_msg,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [(item === null || item === void 0 ? void 0 : item.fullName) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    style: {
                      textTransform: "capitalize"
                    },
                    children: item === null || item === void 0 ? void 0 : item.fullName
                  }), (item === null || item === void 0 ? void 0 : item.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    children: [item === null || item === void 0 ? void 0 : item.email, " (", item === null || item === void 0 ? void 0 : item.userTypeSlug, ")"]
                  })]
                })
              })]
            })
          }, "plist_".concat(i));
        })), loading && Array(6).fill().map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
            sx: {
              maxWidth: "100%",
              padding: "0 15px",
              margin: "-16px 0",
              boxShadow: "none"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
              avatar: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                variant: "circular",
                width: 40,
                height: 40
              }),
              title: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "80%",
                style: {
                  marginBottom: 6
                }
              }),
              subheader: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "40%"
              })
            })
          }, i);
        }), (userList === null || userList === void 0 ? void 0 : userList.length) === 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (list_module_default()).no_found,
          children: "No User Found"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
        sx: {
          padding: "12px 20px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "btn btn-cancel btn-md",
          onClick: handleClose,
          children: "Cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return handleSubmit(activeProfile);
          },
          type: "submit",
          className: "btn btn-secondary btn-md",
          style: {
            minWidth: "82px"
          },
          children: "Add"
        })]
      })]
    })]
  });
};
/* harmony default export */ var person_list = ((/* unused pure expression or super */ null && (PersonList)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/tfi/index.esm.js
var tfi_index_esm = __webpack_require__(81873);
// EXTERNAL MODULE: ./node_modules/react-scroll-to-bottom/lib/esm/index.js + 56 modules
var esm = __webpack_require__(17352);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/message_component/message.module.scss
var message_module = __webpack_require__(42891);
var message_module_default = /*#__PURE__*/__webpack_require__.n(message_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/message_component/index.jsx




/* eslint-disable @next/next/no-img-element */













var MessageComponent = function MessageComponent(_ref) {
  var _messages$, _connectedUserList$fi6, _connectedUserList$fi7, _myMessages$replace;

  var profileInfo = _ref.profileInfo,
      messages = _ref.messages,
      setMessages = _ref.setMessages,
      scrolref = _ref.scrolref,
      _ref$currentChat = _ref.currentChat,
      currentChat = _ref$currentChat === void 0 ? (_messages$ = messages[0]) === null || _messages$ === void 0 ? void 0 : _messages$.receiver : _ref$currentChat,
      getConnectedUserList = _ref.getConnectedUserList,
      _ref$connectedUserLis = _ref.connectedUserList,
      connectedUserList = _ref$connectedUserLis === void 0 ? false : _ref$connectedUserLis,
      chatId = _ref.chatId,
      socket = _ref.socket,
      setArrivalMessage = _ref.setArrivalMessage,
      closeDrawer = _ref.closeDrawer,
      openDrawer = _ref.openDrawer;

  //message state
  var _useState = (0,react.useState)(""),
      myMessages = _useState[0],
      setMyMessages = _useState[1];

  var _useState2 = (0,react.useState)(""),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var addNewLineToTextArea = function addNewLineToTextArea() {
    var msg_text = myMessages + "\r\n";
    setMyMessages(msg_text);
  }; //when press enter send message


  var handleKeyPress = function handleKeyPress(e) {
    var _e$target$value, _e$target$value$repla;

    if (e.keyCode === 13 && e.shiftKey) {
      e.preventDefault();
      addNewLineToTextArea();
    } else if (e.keyCode === 13 && ((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : (_e$target$value$repla = _e$target$value.replace(/\s/g, "")) === null || _e$target$value$repla === void 0 ? void 0 : _e$target$value$repla.length) >= 1 && !loading) {
      handleSubmitMessage();
    }
  }; // push new message


  var handleSubmitMessage = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _connectedUserList$fi, _connectedUserList$fi2;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return api/* default.post */.Z.post("/chat-service/new-meessage", {
                uid: chatId,
                messages: myMessages,
                recieverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi = connectedUserList.find(function (item) {
                  return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                })) === null || _connectedUserList$fi === void 0 ? void 0 : (_connectedUserList$fi2 = _connectedUserList$fi.receiver) === null || _connectedUserList$fi2 === void 0 ? void 0 : _connectedUserList$fi2.id,
                recieverType: "university",
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(res) {
                  var _connectedUserList$fi3, _connectedUserList$fi4, _connectedUserList$fi5;

                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!res.error) {
                            setMyMessages("");
                            getConnectedUserList();
                            setMessages(function (prev) {
                              var _res$data, _res$data2, _res$data3, _res$data4, _res$data5, _res$data6, _res$data7, _res$data8, _res$data9, _res$data10, _res$data11, _res$data12;

                              return [].concat((0,toConsumableArray/* default */.Z)(prev), [{
                                id: (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.id,
                                uid: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.uid,
                                studentId: (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.studentId,
                                senderType: (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.senderType,
                                universityId: (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.universityId,
                                university: (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.university,
                                mentorId: (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.mentorId,
                                mentor: (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.mentor,
                                recieverType: (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.recieverType,
                                messages: (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.messages,
                                createdAt: (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.createdAt,
                                senderTime: res === null || res === void 0 ? void 0 : (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.senderTime
                              }]);
                            });
                            setArrivalMessage(null);
                            socket.current.emit("send-message", {
                              senderId: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id,
                              receiverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi3 = connectedUserList.find(function (item) {
                                return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                              })) === null || _connectedUserList$fi3 === void 0 ? void 0 : (_connectedUserList$fi4 = _connectedUserList$fi3.receiver) === null || _connectedUserList$fi4 === void 0 ? void 0 : (_connectedUserList$fi5 = _connectedUserList$fi4.id) === null || _connectedUserList$fi5 === void 0 ? void 0 : _connectedUserList$fi5.toString(),
                              text: myMessages,
                              senderTime: new Date()
                            });
                            setLoading(false);
                          } else {
                            setLoading(false);
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmitMessage() {
      return _ref2.apply(this, arguments);
    };
  }(); // rendar message


  var RenderMessage = function RenderMessage(msgData) {
    var _msgData$receiver, _msgData$receiver2, _msgData$receiver3;

    if ((msgData === null || msgData === void 0 ? void 0 : msgData.is_first) == 1) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "chat_time",
        style: {
          fontSize: "13px"
        },
        children: msgData === null || msgData === void 0 ? void 0 : msgData.messages
      });
    } else if (msgData && (msgData === null || msgData === void 0 ? void 0 : msgData.studentId) === (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id) && (msgData === null || msgData === void 0 ? void 0 : msgData.senderType) === "student") {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).my_msg_wrapper,
        children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (message_module_default()).my_msg_time,
          children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).my_msg,
          children: [(0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages), (msgData === null || msgData === void 0 ? void 0 : msgData.is_read) == 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneOutline */.xOC, {
            className: (message_module_default()).mark
          })]
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).buddy_msg_wrapper,
      children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (message_module_default()).msg_time,
        children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).msg_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).image_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            style: (msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver = msgData.receiver) === null || _msgData$receiver === void 0 ? void 0 : _msgData$receiver.userTypeSlug) === "university" ? {
              objectFit: "contain"
            } : {},
            src: msgData !== null && msgData !== void 0 && (_msgData$receiver2 = msgData.receiver) !== null && _msgData$receiver2 !== void 0 && _msgData$receiver2.media ? msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver3 = msgData.receiver) === null || _msgData$receiver3 === void 0 ? void 0 : _msgData$receiver3.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
            alt: "avatar"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).replymsg,
          children: (0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages)
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (message_module_default()).message_component_wrapper,
    children: [currentChat && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).heading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(tfi_index_esm/* TfiMenu */.lrj, {
        className: (message_module_default()).heading_menu,
        onClick: openDrawer
      }), connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi6 = connectedUserList.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
      })) === null || _connectedUserList$fi6 === void 0 ? void 0 : (_connectedUserList$fi7 = _connectedUserList$fi6.receiver) === null || _connectedUserList$fi7 === void 0 ? void 0 : _connectedUserList$fi7.name]
    }), messages && currentChat ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.ZP, {
        className: (message_module_default()).conversation_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).conversation_wrapper_child,
          children: messages && (messages === null || messages === void 0 ? void 0 : messages.length) > 0 && (messages === null || messages === void 0 ? void 0 : messages.map(function (msgData, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "chat_scroll",
              id: "chat_scroll",
              children: RenderMessage(msgData)
            }, (Math.random() + 1).toString(36).substring(7));
          }))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (message_module_default()).msg_footer_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).action,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (message_module_default()).left,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (message_module_default()).image_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                alt: "profile",
                src: profileInfo !== null && profileInfo !== void 0 && profileInfo.profileImageSrc ? profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.profileImageSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
              "aria-label": "minimum height",
              style: {
                minHeight: "40px"
              },
              placeholder: "Reply Message...",
              value: myMessages !== null && myMessages !== void 0 ? myMessages : "",
              onChange: function onChange(e) {
                setMyMessages(e.target.value);
              },
              onKeyDown: function onKeyDown(e) {
                if (e.key === "Enter") {
                  e.preventDefault();
                }

                handleKeyPress(e);
              }
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (message_module_default()).action_btn,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
              disabled: (myMessages === null || myMessages === void 0 ? void 0 : (_myMessages$replace = myMessages.replace(/\s/g, "")) === null || _myMessages$replace === void 0 ? void 0 : _myMessages$replace.length) >= 1 ? false : true,
              onClick: handleSubmitMessage,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdSend */.D6S, {})
            })
          })]
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (message_module_default()).details_wrapper2,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).empty_detail_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Select a chat or start a new conversation"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: openDrawer,
          className: "btn btn-outline-grey btn-sm",
          children: "Start"
        })]
      })
    })]
  });
};
/* harmony default export */ var message_component = ((/* unused pure expression or super */ null && (MessageComponent)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_profile/index.jsx




var person_profile_excluded = (/* unused pure expression or super */ null && (["data", "profileType"]));


function person_profile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function person_profile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? person_profile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : person_profile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @next/next/no-img-element */














var customStyles = {
  control: function control(base, state) {
    var _objectSpread2;

    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, (_objectSpread2 = {
      minHeight: "46px",
      boxShadow: state.isFocused ? "none" : "none",
      borderColor: "none",
      "&:hover": {
        borderColor: "none"
      }
    }, (0,defineProperty/* default */.Z)(_objectSpread2, "borderColor", state.isFocused ? "#f5f8fa" : "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "backgroundColor", "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "fontSize", "14px"), _objectSpread2));
  },
  option: function option(provided, state) {
    return person_profile_objectSpread(person_profile_objectSpread({}, provided), {}, {
      cursor: "pointer",
      fontSize: "14px",
      transition: "all 0.3s",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  },
  menuList: function menuList(base) {
    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, {
      "::-webkit-scrollbar": {
        width: "5px",
        height: "6px",
        overflow: "visible",
        cursor: "pointer",
        background: "transparent",
        borderRadius: "10px"
      },
      "::-webkit-scrollbar-thumb": {
        background: "rgb(202, 202, 202)",
        borderRadius: "10px",
        cursor: "pointer"
      }
    });
  }
};
var PersonProfile = function PersonProfile(_ref) {
  var _data$name, _profileInfo$workingC, _profileInfo$preferen, _profileInfo$preferen2, _profileInfo$preferen3, _profileInfo$preferen4, _profileInfo$preferen5, _profileInfo$preferen6, _profileInfo$preferen7, _profileInfo$preferen8, _profileInfo$preferen9, _profileInfo$preferen10, _profileInfo$preferen11, _profileInfo$preferen12, _profileInfo$preferen13, _profileInfo$preferen14, _profileInfo$preferen15, _profileInfo$preferen16, _profileInfo$preferen17, _profileInfo$preferen18, _profileInfo$preferen19, _profileInfo$preferen20, _profileInfo$preferen21, _profileInfo$preferen22, _profileInfo$preferen23, _profileInfo$preferen24, _profileInfo$preferen25, _profileInfo$preferen26, _profileInfo$preferen27, _profileInfo$preferen28, _profileInfo$preferen29, _profileInfo$preferen30, _profileInfo$preferen31, _profileInfo$preferen32, _profileInfo$preferen33, _profileInfo$preferen34, _profileInfo$preferen35, _profileInfo$preferen36, _profileInfo$preferen37, _profileInfo$preferen38;

  var data = _ref.data,
      profileType = _ref.profileType,
      props = _objectWithoutProperties(_ref, person_profile_excluded);

  var tZone = getTimeZone();

  var _React$useState = React.useState(new Date()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _useState = useState(moment.tz.guess()),
      currentTzone = _useState[0],
      setCurrentTzone = _useState[1];

  var _useState2 = useState(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      showInMobile = _useState3[0],
      setShowInMobile = _useState3[1];

  var _useState4 = useState(),
      timeSlot = _useState4[0],
      setTimeslot = _useState4[1];

  var _useState5 = useState({}),
      profileInfo = _useState5[0],
      setProfileInfo = _useState5[1];

  var _useState6 = useState(),
      index = _useState6[0],
      setIndex = _useState6[1];

  var getProfile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return API.get("/user/any-profile?userType=".concat(profileType, "&id=").concat(data === null || data === void 0 ? void 0 : data.id)).then(function (res) {
                if (!res.error) {
                  setProfileInfo(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getProfile() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && profileType) {
      getProfile();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, profileType]);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              payload = {
                date: value,
                counsellorId: data === null || data === void 0 ? void 0 : data.id,
                timezone: currentTzone
              };
              _context2.next = 3;
              return API.post("/student/counsellor-appointment/time-list", payload).then(function (res) {
                if (!res.error) {
                  setTimeslot(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && value && currentTzone && profileType === "counsellor") {
      handleSubmit();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, value, currentTzone, profileType]);

  function formatAMPM(time) {
    // return time;
    var hour = time.split(":");
    var hrs = parseInt(hour[0]);
    var ampm = hrs >= 12 ? "pm" : "am";
    hrs = hrs % 12;
    hrs = hrs ? hrs : 12; // the hour '0' should be '12'

    var strTime = hrs + ":" + hour[1] + " " + ampm;
    return strTime;
  }

  var handleOpen = function handleOpen() {
    setOpen(true);
    document.body.classList.add("popOpen");
    handleSubmit();
  };

  var handleClose = function handleClose() {
    setOpen(false);
    document.body.classList.remove("popOpen");
    setIndex();
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.profile_wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.image_wrapper,
      children: /*#__PURE__*/_jsx("img", {
        src: data.profileImage ? data.profileImage : getAssets("assets/student-avatar-big.png"),
        alt: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : ""
      })
    }), /*#__PURE__*/_jsx("h2", {
      children: data.name
    }), profileType && profileType == "counsellor" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.profile_bio,
        children: [profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && htmlParse(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio), profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && /*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: "/app/student/counsellor/".concat(data === null || data === void 0 ? void 0 : data.id),
          children: /*#__PURE__*/_jsx("a", {
            className: styles.read_more,
            children: "Read More"
          })
        })]
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && /*#__PURE__*/_jsx("h5", {
        children: "Working Country"
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$workingC = profileInfo.workingCountry) === null || _profileInfo$workingC === void 0 ? void 0 : _profileInfo$workingC.length) > 0 && /*#__PURE__*/_jsx("div", {
        className: styles.country_wrapper,
        children: profileInfo.workingCountry && profileInfo.workingCountry.map(function (item, i) {
          return /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: item
          }, i);
        })
      }), /*#__PURE__*/_jsx("button", {
        onClick: handleOpen,
        className: "btn btn-primary ".concat(styles.book_appiontment),
        children: "Book Appointment"
      })]
    }), profileType && profileType == "student" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen = profileInfo.preferences) === null || _profileInfo$preferen === void 0 ? void 0 : _profileInfo$preferen.courselevel) && /*#__PURE__*/_jsx("h5", {
          children: "Course Level"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen2 = profileInfo.preferences) === null || _profileInfo$preferen2 === void 0 ? void 0 : (_profileInfo$preferen3 = _profileInfo$preferen2.courselevel) === null || _profileInfo$preferen3 === void 0 ? void 0 : _profileInfo$preferen3.levelName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen4 = profileInfo.preferences) === null || _profileInfo$preferen4 === void 0 ? void 0 : (_profileInfo$preferen5 = _profileInfo$preferen4.courselevel) === null || _profileInfo$preferen5 === void 0 ? void 0 : _profileInfo$preferen5.levelName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen6 = profileInfo.preferences) === null || _profileInfo$preferen6 === void 0 ? void 0 : _profileInfo$preferen6.countryPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Country Preferences"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen7 = profileInfo.preferences) === null || _profileInfo$preferen7 === void 0 ? void 0 : _profileInfo$preferen7.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen8 = profileInfo.preferences) === null || _profileInfo$preferen8 === void 0 ? void 0 : (_profileInfo$preferen9 = _profileInfo$preferen8.countryPreferences) === null || _profileInfo$preferen9 === void 0 ? void 0 : _profileInfo$preferen9.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen10 = profileInfo.preferences) === null || _profileInfo$preferen10 === void 0 ? void 0 : _profileInfo$preferen10.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen11 = profileInfo.preferences) === null || _profileInfo$preferen11 === void 0 ? void 0 : (_profileInfo$preferen12 = _profileInfo$preferen11.countryPreferences) === null || _profileInfo$preferen12 === void 0 ? void 0 : _profileInfo$preferen12.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen13 = profileInfo.preferences) === null || _profileInfo$preferen13 === void 0 ? void 0 : _profileInfo$preferen13.studyPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Preferred Courses"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen14 = profileInfo.preferences) === null || _profileInfo$preferen14 === void 0 ? void 0 : _profileInfo$preferen14.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen15 = profileInfo.preferences) === null || _profileInfo$preferen15 === void 0 ? void 0 : (_profileInfo$preferen16 = _profileInfo$preferen15.studyPreferences) === null || _profileInfo$preferen16 === void 0 ? void 0 : _profileInfo$preferen16.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen17 = profileInfo.preferences) === null || _profileInfo$preferen17 === void 0 ? void 0 : _profileInfo$preferen17.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen18 = profileInfo.preferences) === null || _profileInfo$preferen18 === void 0 ? void 0 : (_profileInfo$preferen19 = _profileInfo$preferen18.studyPreferences) === null || _profileInfo$preferen19 === void 0 ? void 0 : _profileInfo$preferen19.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen20 = profileInfo.preferences) === null || _profileInfo$preferen20 === void 0 ? void 0 : _profileInfo$preferen20.specialization) && /*#__PURE__*/_jsx("h5", {
          children: "Specialization"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen21 = profileInfo.preferences) === null || _profileInfo$preferen21 === void 0 ? void 0 : (_profileInfo$preferen22 = _profileInfo$preferen21.specialization) === null || _profileInfo$preferen22 === void 0 ? void 0 : _profileInfo$preferen22.specializationName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen23 = profileInfo.preferences) === null || _profileInfo$preferen23 === void 0 ? void 0 : (_profileInfo$preferen24 = _profileInfo$preferen23.specialization) === null || _profileInfo$preferen24 === void 0 ? void 0 : _profileInfo$preferen24.specializationName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen25 = profileInfo.preferences) === null || _profileInfo$preferen25 === void 0 ? void 0 : _profileInfo$preferen25.intakePreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Intake"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen26 = profileInfo.preferences) === null || _profileInfo$preferen26 === void 0 ? void 0 : _profileInfo$preferen26.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen27 = profileInfo.preferences) === null || _profileInfo$preferen27 === void 0 ? void 0 : (_profileInfo$preferen28 = _profileInfo$preferen27.intakePreferences) === null || _profileInfo$preferen28 === void 0 ? void 0 : _profileInfo$preferen28.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen29 = profileInfo.preferences) === null || _profileInfo$preferen29 === void 0 ? void 0 : _profileInfo$preferen29.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen30 = profileInfo.preferences) === null || _profileInfo$preferen30 === void 0 ? void 0 : (_profileInfo$preferen31 = _profileInfo$preferen30.intakePreferences) === null || _profileInfo$preferen31 === void 0 ? void 0 : _profileInfo$preferen31.map(function (item, i) {
            var year = item.year,
                data = item.data;
            var last = Object.keys(data).length - 1;
            var payload = {
              year: year,
              from: data[Object.keys(data)[0]],
              to: data[Object.keys(data)[last]]
            };
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: "".concat(payload.from, "-").concat(payload.to, ", ").concat(payload.year)
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen32 = profileInfo.preferences) === null || _profileInfo$preferen32 === void 0 ? void 0 : _profileInfo$preferen32.budget) && /*#__PURE__*/_jsx("h5", {
          children: "Budget"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen33 = profileInfo.preferences) === null || _profileInfo$preferen33 === void 0 ? void 0 : _profileInfo$preferen33.budget) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen34 = profileInfo.preferences) === null || _profileInfo$preferen34 === void 0 ? void 0 : _profileInfo$preferen34.budget
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen35 = profileInfo.preferences) === null || _profileInfo$preferen35 === void 0 ? void 0 : _profileInfo$preferen35.objective) && /*#__PURE__*/_jsx("h5", {
          children: "Objective"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen36 = profileInfo.preferences) === null || _profileInfo$preferen36 === void 0 ? void 0 : _profileInfo$preferen36.objective) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen37 = profileInfo.preferences) === null || _profileInfo$preferen37 === void 0 ? void 0 : (_profileInfo$preferen38 = _profileInfo$preferen37.objective) === null || _profileInfo$preferen38 === void 0 ? void 0 : _profileInfo$preferen38.objectivePurpose
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      open: open,
      onClose: handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "modal ".concat(styles.modal_custom_width),
        children: [/*#__PURE__*/_jsx("button", {
          className: "".concat(styles.cross_icon, " cross_icon"),
          onClick: handleClose,
          children: /*#__PURE__*/_jsx(FiX, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.appoint_modal,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.appoint_modal_right,
            children: [/*#__PURE__*/_jsx("h3", {
              className: styles.appoint_title,
              children: "Select a Date & Time"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.appoint_calender_and_time_wrapper,
              children: [/*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.calender_and_time_zone_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    maxHeight: "310px"
                  },
                  children: /*#__PURE__*/_jsx(LocalizationProvider, {
                    dateAdapter: AdapterDateFns,
                    children: /*#__PURE__*/_jsx(StaticDatePicker, {
                      className: "appointModalDatePicker",
                      displayStaticWrapperAs: "desktop",
                      openTo: "day",
                      minDate: new Date(),
                      value: value,
                      onChange: function onChange(newValue) {
                        setValue(newValue);
                        setShowInMobile(true);
                        setIndex();
                      },
                      renderInput: function renderInput(params) {
                        return /*#__PURE__*/_jsx(TextField, person_profile_objectSpread({}, params));
                      }
                    })
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.time_zone_wrapper,
                  children: [/*#__PURE__*/_jsx("label", {
                    className: styles.label,
                    children: "Select Time Zone"
                  }), /*#__PURE__*/_jsx(Select, {
                    menuPlacement: "top",
                    placeholder: "Select Timezone",
                    styles: customStyles,
                    options: tZone,
                    value: currentTzone && tZone ? tZone.filter(function (tz) {
                      return tz.value == currentTzone;
                    }) : "",
                    onChange: function onChange(item) {
                      setCurrentTzone(item.value);
                      setIndex();
                    }
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.appoint_time_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsxs("div", {
                  className: styles.back_icon_and_date_wrapper,
                  children: [/*#__PURE__*/_jsx(IconButton, {
                    onClick: function onClick() {
                      return setShowInMobile(false);
                    },
                    className: styles.back_btn,
                    children: /*#__PURE__*/_jsx(ArrowBackIcon, {})
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.appoint_time_title,
                    children: new Date(value).toDateString()
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.appoint_time_list_wrapper,
                  children: /*#__PURE__*/_jsx("ul", {
                    children: timeSlot && timeSlot.length > 0 ? timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.map(function (item, i) {
                      return /*#__PURE__*/_jsxs("li", {
                        children: [/*#__PURE__*/_jsxs("button", {
                          onClick: function onClick() {
                            return setIndex(i);
                          },
                          className: "".concat(styles.appoint_time_btn, " ").concat(index === i ? styles.active : ""),
                          children: [formatAMPM(item === null || item === void 0 ? void 0 : item.startTime), "-", formatAMPM(item === null || item === void 0 ? void 0 : item.endTime)]
                        }), /*#__PURE__*/_jsx("button", {
                          className: "".concat(styles.confirm_btn, " ").concat(index === i ? styles.active : "", " btn btn-secondary btn-bg"),
                          onClick: function onClick() {
                            handleFormSubmit(item === null || item === void 0 ? void 0 : item.timeId);
                          },
                          children: "Confirm"
                        })]
                      }, i);
                    }) : /*#__PURE__*/_jsx("li", {
                      className: styles.no_record,
                      children: "\"No Appoinment Schedule\""
                    })
                  })
                })]
              })]
            })]
          })
        })]
      })
    })]
  });
};
/* harmony default export */ var person_profile = ((/* unused pure expression or super */ null && (PersonProfile)));
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/index.js



// EXTERNAL MODULE: ./_unisearch/common/form/index.js + 15 modules
var common_form = __webpack_require__(15603);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
;// CONCATENATED MODULE: ./_unisearch/common/download_guide/index.jsx


var download_guide_excluded = ["fileSrc", "btnTitle", "fileName", "documentType", "customClasses", "customStyles", "universityId", "documentId"];











/*
documentType -> 'prospectus', 'exam', 'document', 'course', 'ebook', 'countryguide'

This componetn takes props
-> fileSrc
-> fileName
-> btnTitle
-> documentType
-> universityId
-> documentId
-> customClasses={
        root.[your class name]
    }
-> customClasses={
        title.[your class name]
   }
-> customClasses={
        tooltip.[your class name]
    }
-> customStyles={{ root: { color: "blue" } }}
-> customStyles={{ title: { fontSize: "30px" } }}
-> customStyles={{ tooltip: { color: "blue" } }}
 */



var DownloadGuide = function DownloadGuide(_ref) {
  var fileSrc = _ref.fileSrc,
      btnTitle = _ref.btnTitle,
      fileName = _ref.fileName,
      _ref$documentType = _ref.documentType,
      documentType = _ref$documentType === void 0 ? "prospectus" : _ref$documentType,
      customClasses = _ref.customClasses,
      customStyles = _ref.customStyles,
      _ref$universityId = _ref.universityId,
      universityId = _ref$universityId === void 0 ? 0 : _ref$universityId,
      _ref$documentId = _ref.documentId,
      documentId = _ref$documentId === void 0 ? 0 : _ref$documentId,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, download_guide_excluded);

  var router = (0,next_router.useRouter)();
  var systemActions = (0,_actions/* useSystemActions */.x3)();
  var profileInfos = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);

  var _useState = (0,react.useState)(),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  (0,react.useEffect)(function () {
    setProfileInfo(profileInfos);
  }, []);

  var storeStudentDownloadInfo = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api/* default.post */.Z.post("/student/download-activity", {
                universityId: universityId,
                type: documentType,
                mediaId: documentId
              }).then(function (res) {});

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              (0,helpers/* swalError */.Kj)("Something went wrong");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function storeStudentDownloadInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDownload = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(fileSrc) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (profileInfo) {
                _context2.next = 3;
                break;
              }

              systemActions.setReturnUrl(router.asPath);
              return _context2.abrupt("return", router.push({
                pathname: "/signin"
              }));

            case 3:
              if (profileInfo && profileInfo.userTypeSlug === "student") {
                storeStudentDownloadInfo();
              }

              window.open(fileSrc, "_blank");

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDownload(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
    onClick: function onClick() {
      handleDownload(fileSrc);
    },
    className: "btn btn-secondary relative ".concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
    style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdPictureAsPdf */.OY_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "".concat(customClasses !== null && customClasses !== void 0 && customClasses.title ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.title : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.title,
      children: btnTitle || "Download Brochure"
    }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "uni-tooltip ".concat(customClasses !== null && customClasses !== void 0 && customClasses.tooltip ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.tooltip : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.tooltip,
      children: ["Please Login ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " to perform this action"]
    })]
  });
};
/* harmony default export */ var download_guide = ((/* unused pure expression or super */ null && (DownloadGuide)));
;// CONCATENATED MODULE: ./_unisearch/common/index.js





/***/ }),

/***/ 13991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _modules_study_university__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97623);
/* harmony import */ var _unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81496);
/* harmony import */ var _modules_study_university_uni_ranking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4013);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);







var Ranking = function Ranking(_ref) {
  var universityProfileData = _ref.universityProfileData,
      universityRankings = _ref.universityRankings,
      rankingOverviewText = _ref.rankingOverviewText,
      country_name = _ref.country_name,
      university_name = _ref.university_name;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_2__/* .LayoutMain */ .Ku, {
    footer_with_evaluation: true,
    title: universityProfileData ? "".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, " - Ranking") : "",
    metaDescription: rankingOverviewText ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_4__/* .excerpt */ .X1)(rankingOverviewText, 300) : "In the process of researching universities you want to apply to, you’ve likely run into university rankings. But what do these numbers mean? A lot goes into informing the position a university or college holds in some of the most popular ranking lists. QS Top Universities, Times Higher Education, US News, Shanghai Rankings, etc. all collect and analyse a lot of data to determine what makes a university a great destination for students. Understanding this data also helps you figure out how to choose the right university for yourself!",
    metaImage: (universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.featureSrc) || (universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.coverphotoLogoSrc),
    metaUrl: "".concat("https://myunisearch.com", "/study/").concat(country_name, "/university/").concat(university_name, "/ranking"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_university__WEBPACK_IMPORTED_MODULE_1__/* .UniProfileWrapper */ .au, {
        uniProfileData: universityProfileData || {},
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_university_uni_ranking__WEBPACK_IMPORTED_MODULE_3__/* .UniRanking */ .k_, {
          rankingInfo: universityRankings,
          rankingOverviewText: rankingOverviewText
        })
      })
    })
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Ranking);

/***/ }),

/***/ 2303:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study/[country_name]/university/[university_name]/ranking",
      function () {
        return __webpack_require__(13991);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"course_ranking_card":"course_ranking_card_course_ranking_card__sRQYO","ranking_heading":"course_ranking_card_ranking_heading__pI_0s","trophy_icon":"course_ranking_card_trophy_icon__XP5UU","rank_num":"course_ranking_card_rank_num__1S_1Z","rank_year":"course_ranking_card_rank_year__KRiUf","ranking_title":"course_ranking_card_ranking_title__6zGMy","rank_list":"course_ranking_card_rank_list__hR9dQ","num":"course_ranking_card_num__dfnDl","text":"course_ranking_card_text__TbTGw","toggle_icon":"course_ranking_card_toggle_icon__XW8bU","active":"course_ranking_card_active__QADfU","active_child":"course_ranking_card_active_child__Mm2bL"};

/***/ }),

/***/ 30890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"play_btn_with_ripple_play_btn__yNA0_","arrow_right":"play_btn_with_ripple_arrow_right__Fmzao","ripple_effect":"play_btn_with_ripple_ripple_effect__4Jxcn","ModalRipple":"play_btn_with_ripple_ModalRipple__5yAi9","medium":"play_btn_with_ripple_medium__ClXl0","small":"play_btn_with_ripple_small__EszEQ","orange":"play_btn_with_ripple_orange__1q96e"};

/***/ }),

/***/ 47384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_thumb_grid_box___next__PWbmq","box":"uni_thumb_grid_box_box__W9voa","image_wrapper":"uni_thumb_grid_box_image_wrapper__AWQY2","banner":"uni_thumb_grid_box_banner__Zf_6n","logo_wrapper":"uni_thumb_grid_box_logo_wrapper__Cp3oL","logo":"uni_thumb_grid_box_logo__RM_tL","profile_box_content":"uni_thumb_grid_box_profile_box_content__gak3t","infos":"uni_thumb_grid_box_infos__fPlcm","name":"uni_thumb_grid_box_name__MElzQ","info":"uni_thumb_grid_box_info__WO_dQ","icon":"uni_thumb_grid_box_icon__Pqn4E","follow":"uni_thumb_grid_box_follow__PN7Lc","links":"uni_thumb_grid_box_links__AhukV","popular_courses":"uni_thumb_grid_box_popular_courses__JISnW","first":"uni_thumb_grid_box_first__snPsV","last":"uni_thumb_grid_box_last__apQqX","all_courses":"uni_thumb_grid_box_all_courses__KKNUC"};

/***/ }),

/***/ 47022:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_uni_brief":"uni_brief_section_uni_brief__HDqFd","brief_wrapper":"uni_brief_brief_wrapper__L8JIS","brief_left_wrapper":"uni_brief_brief_left_wrapper__LVU6c","uni_logo_wrapper":"uni_brief_uni_logo_wrapper__GRSAp","uni_brief_info":"uni_brief_uni_brief_info__K7_DQ","brief_right_wrapper":"uni_brief_brief_right_wrapper__SV0_H","info_rating_stars":"uni_brief_info_rating_stars__kasMS","info_rating_number":"uni_brief_info_rating_number__QLgq6","uni_web_link":"uni_brief_uni_web_link__KgEaj","compare_wrapper":"uni_brief_compare_wrapper__qDVt3","icon_heart":"uni_brief_icon_heart__kAVta","icon_swap":"uni_brief_icon_swap__MeiHF","rating_wrapper":"uni_brief_rating_wrapper__xFFKY","modal_header":"uni_brief_modal_header__NDrGT","modal_body":"uni_brief_modal_body__lfBwt","modal_title":"uni_brief_modal_title__E8rR7","modal_description":"uni_brief_modal_description__yvCMC","action_btn":"uni_brief_action_btn__yH_0f","active_btn":"uni_brief_active_btn__VgSdv"};

/***/ }),

/***/ 47656:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uni_hero":"uni_hero_with_video_uni_hero__EYNPe","video_wrapper":"uni_hero_with_video_video_wrapper__zyLOm","overlay":"uni_hero_with_video_overlay__H6twK"};

/***/ }),

/***/ 13777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_links___next__muTBt","section_links":"uni_links_section_links__xN6Wg","links_wrapper":"uni_links_links_wrapper__VqfJE","links_container":"uni_links_links_container__y3gQ7","link_lists":"uni_links_link_lists__aXFrS","link_list_item":"uni_links_link_list_item__1VTz2","active":"uni_links_active__w_Jji","currencyChanger":"uni_links_currencyChanger__AAlM8"};

/***/ }),

/***/ 98576:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_profile_banner___next__ExBkw","section_banner":"uni_profile_banner_section_banner__7vgrZ","banner_wrapper":"uni_profile_banner_banner_wrapper__widLd","banner_image":"uni_profile_banner_banner_image__R_T_c"};

/***/ }),

/***/ 98281:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"uni_profile_wrapper_root__IDxrR","uni_breacrumbs":"uni_profile_wrapper_uni_breacrumbs__jGbp2"};

/***/ }),

/***/ 38927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"uni_ranking_title_wrapper__Njdc_","heading":"uni_ranking_heading__snukr","ranking_wrapper":"uni_ranking_ranking_wrapper__53SwY","ranking_company_wrapper":"uni_ranking_ranking_company_wrapper__fLkuP","rank_company_logo_wrapper":"uni_ranking_rank_company_logo_wrapper__FH0dU","rank_company_title":"uni_ranking_rank_company_title__KgFR5","rank_company_desc":"uni_ranking_rank_company_desc__HXWjN"};

/***/ }),

/***/ 88740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"guest_form_review_wrapper__u7nu7","rating_wrapper":"guest_form_review_rating_wrapper__I5gca","input_wrapper":"guest_form_review_input_wrapper__Y_rPr","text_input_wrapper":"guest_form_review_text_input_wrapper__3sak2","action_btn":"guest_form_review_action_btn__C_nI2","phoneInput":"guest_form_review_phoneInput__ui0mH"};

/***/ }),

/***/ 42891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message_component_wrapper":"message_message_component_wrapper__1ieyP","buddy_msg_wrapper":"message_buddy_msg_wrapper__DK00E","msg_time":"message_msg_time__pkHde","msg_wrapper":"message_msg_wrapper__bcN0z","image_wrapper":"message_image_wrapper__75POr","replymsg":"message_replymsg__Q1uk8","my_msg_time":"message_my_msg_time__RxJqO","my_msg":"message_my_msg__0MTvI","mark":"message_mark__3uB3z","heading":"message_heading__nN8Pc","details_wrapper":"message_details_wrapper__KVYfo","msg_footer_wrapper":"message_msg_footer_wrapper__S9kxU","action":"message_action__0Olen","left":"message_left__1Zl0o","action_btn":"message_action_btn__l9bDv","conversation_wrapper":"message_conversation_wrapper__YdB1H","conversation_wrapper_child":"message_conversation_wrapper_child__50fY7","details_wrapper2":"message_details_wrapper2__mMBhj","empty_detail_wrapper":"message_empty_detail_wrapper__SuI8J","my_msg_wrapper":"message_my_msg_wrapper__PTorz","heading_menu":"message_heading_menu__Kqe7o"};

/***/ }),

/***/ 6867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"active_chatt_box":"list_active_chatt_box__MbZyB","chatt":"list_chatt__Y9S5q","time":"list_time__brnw_","image_wrapper":"list_image_wrapper__waMIN","active_chatt_box_modal":"list_active_chatt_box_modal___BrsY","chatt_box":"list_chatt_box__GiEyE","chatt_msg":"list_chatt_msg__KF_sP","chatt_box_wrapper":"list_chatt_box_wrapper__4qk6k","list_wrapper":"list_list_wrapper__DX7IH","search_input":"list_search_input__2YMvn","search_icon":"list_search_icon__3ZZ8U","header_wrapper":"list_header_wrapper__elCsP","btn_group":"list_btn_group__POPeU","search_input_modal":"list_search_input_modal___ZcDT","modal_body":"list_modal_body__nHnG8","no_found":"list_no_found__wMd8W","btn_close":"list_btn_close__2T9Vb","btn_add_user":"list_btn_add_user__9cjH4","btn_plus":"list_btn_plus__B7L_4"};

/***/ }),

/***/ 73873:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41548:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,260,1086,2884,8719,8322,5824,3480,5551,5260,926,3063,6066,6665,3023,1496,5603,9774,2888,179], function() { return __webpack_exec__(2303); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);